import { Box } from "@chakra-ui/react";
import {
  call,
  ColorIcon,
  colors,
  customEvent,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  getCdnImageSrc,
  GoiLogo,
  HackleEventName,
  HStack,
  Image,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  OverlayModal,
  Spacing,
  VStack,
} from "goi_common";
import { ReactNode, useMemo } from "react";
import ParlorRegionBreadcrumb from "../../ParlorRegionContainer/ParlorRegionBreadcrumb";
import { ConsultReservationModalContent } from "./Modal/ConsultReservationModalContent";
import { useRouter } from "next/router";
import { useOverlay } from "@toss/use-overlay";

interface MainInfoProps {
  companyName: string;
  address: string;
  sido?: string;
  sigungu?: string;
  isDiscount?: boolean;
  id?: string;
  isExcluded: boolean;
}
function MainInfoSection({
  companyName,
  address,
  sido,
  sigungu,
  isDiscount,
  id,
  isExcluded,
}: MainInfoProps) {
  const router = useRouter();
  const overlay = useOverlay();

  const onDiscountClick = () => {
    call("1666-9784");
  };
  const onFuneralClick = () => {
    overlay.open(({ isOpen, close: onClose }) => {
      return (
        <OverlayModal
          onClose={onClose}
          isOpen={isOpen}
          closeOnOverlayClick={true}
          modalContentStyle={{
            minWidth: "340px",
          }}
          overlayModalContent={
            <ConsultReservationModalContent companyname={companyName} onClose={onClose} />
          }
        />
      );
    });
  };

  const is76 = useMemo(() => {
    return String(id) === "76";
  }, [id]);
  const alert76 = () => {
    if (is76) {
      alert(
        "본 홈페이지는 고이장례연구소에서 제공하는 장례식장 정보로, 포항국화원장례식장에 직접 문의하시고자 하시는 경우 검색포탈사이트를 이용해주세요. ",
      );
    }
  };

  return (
    <VStack width="100%">
      <VStack padding="16px 24px 12px" alignItems="flex-start" maxWidth="480px">
        <Box position={"relative"} top={0}>
          <ParlorRegionBreadcrumb
            path="parlor_detail"
            sidoName={FUNERAL_SIDO.get(Number(sido)) as string}
            sigunguName={FUNERAL_SIGUNGU.get(Number(sido))?.get(Number(sigungu)) as string}
          />
        </Box>

        {isDiscount && (
          <Box
            mt="8px"
            mb="6px"
            background="rgba(0, 0, 0, 0.5)"
            backdropFilter="blur(2px)"
            borderRadius="18px"
            padding="2px 10px 2px 2px"
          >
            <HStack gap="4px" alignItems="center" justifyContent="center">
              <Box margin="auto" background={colors.gray900} padding="4px" borderRadius="50%">
                <ColorIcon
                  name="icon-medal-check-mono"
                  color={colors.reviewYellow}
                  width={16}
                  height={16}
                />
              </Box>
              <HStack gap="6px" alignItems="center" justifyContent="center">
                <GoiLogo color={colors.white} size={16} />
                <span className="button_12_sb white">빈소 할인 제휴 장례식장</span>
              </HStack>
            </HStack>
          </Box>
        )}
        <Box as="h1" className="subtitle1_b gray900">
          {companyName}
        </Box>

        <Spacing gap={8} />
        <HStack width="100%" alignItems="flex-start" justifyContent="space-between" gap={8}>
          <HStack alignItems="flex-start" gap={4} flexGrow={0}>
            <ColorIcon name="location" width="22px" color={colors.orange650} />
            <div className="body3_r gray500">{address}</div>
          </HStack>
          <CopyAddressButton address={address} />
        </HStack>

        {Number(id) === 904 && (
          <VStack padding="12px">
            <Box width="100%" position="relative">
              <VStack>
                <Box className="body_14_m orange650" mb="12px">
                  실제 효사랑장례식장에서 장례를 진행한 상주님이
                  <br />
                  직접 제출해주신 <b className="danger">최종 비용 영수증</b>이에요.
                </Box>
                <Box className="subtitle_16_b black" mb="12px">
                  상단 상세 비용 알아보기를 통하여
                  <br />
                  {`"효사랑 장례식장"`} 기준 장례 총 비용을 확인해보세요.
                </Box>
              </VStack>
              <Box
                position="absolute"
                maxWidth="100%"
                width="100%"
                style={{
                  aspectRatio: (384 + 48) / (682.66 + 48),
                  maxWidth: "100%",
                  backdropFilter: "blur(1px)",
                }}
              ></Box>
              <Image
                src={getCdnImageSrc(`platform/parlor/detail_904_3.png`)}
                alt="목포효사랑장례식장실제비용"
                height="600px"
                width="100%"
              />
            </Box>
          </VStack>
        )}
        {!isExcluded && (
          <HStack
            as="ul"
            justifyContent="space-between"
            width="100%"
            padding="16px 0px 0px 0px"
            gap="8px"
          >
            <BadgeIcon
              hasBorder
              onClick={() => {
                alert76();
                onFuneralClick();
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "call-sangjo_service",
                    text: companyName,
                  },
                });
              }}
              icon={
                <Image
                  width="30px"
                  alt="services"
                  src={getCdnImageSrc("platform/parlor/service.png")}
                />
              }
              title={
                <>
                  <b>상담 예약</b>
                  <br />
                  (남은 시간: <span className="danger subtitle_14_b">1</span>)
                </>
              }
            />
            <BadgeIcon
              onClick={() => {
                alert76();
                onDiscountClick();
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "call-binso_discount",
                    text: companyName,
                  },
                });
              }}
              icon={
                <Image
                  width="60px"
                  alt="binso-discount"
                  src={getCdnImageSrc("platform/parlor/binso-discount.png")}
                />
              }
              title={
                <>
                  <b>빈소 할인 📞</b>
                  <br />
                  문의
                </>
              }
            />

            <BadgeIcon
              onClick={() => {
                alert76();
                router.replace({
                  query: { ...router.query, showFlowerModal: true },
                });
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "call-hwahwan_bonaegi",
                    text: companyName,
                  },
                });
              }}
              icon={
                <Image
                  width="60px"
                  alt="화환"
                  src={getCdnImageSrc("platform/parlor/flowers.png")}
                />
              }
              title={
                <>
                  <b>근조 화환 🌸</b>
                  <br />

                  <HStack>
                    보내기{" "}
                    <Box
                      width="fit-content"
                      padding="2px 4px"
                      className="caption_12_b white"
                      borderRadius="4px"
                      background={colors.danger}
                    >
                      할인
                    </Box>
                  </HStack>
                </>
              }
            />
          </HStack>
        )}
      </VStack>
      <VStack
        width="100%"
        background={colors.gray900}
        padding="12px 16px"
        className="body_16_m gray50"
      >
        예상치 못하게 4일장 혹은 긴 3일장을 치르지 않도록, <br />
        반드시 장례 절차와 빈소 상황을 확인하고 장례 예상 비용을 미리 알아보세요.
        <br />
        <br />
        <VStack width="100%" className="body_16_m white">
          <VStack width="100%" gap="12px">
            <LargeButton
              buttonType={LARGEL_BUTTON_TYPE.WHITE}
              className="subtitle_21_b"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "event_banner-call",
                  },
                });
                call("1666-9784");
              }}
            >
              전화상담
            </LargeButton>
            <LargeButton
              buttonType={LARGEL_BUTTON_TYPE.WHITE}
              className="subtitle_21_b"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "event_banner-match_request",
                  },
                });
                router.push("/match/request/?utm_campaign=parlor_detail");
              }}
            >
              예상 비용 알아보기
            </LargeButton>
          </VStack>
        </VStack>
      </VStack>
    </VStack>
  );
}

const BadgeIcon = ({
  icon,
  title,
  onClick,
  hasBorder,
}: {
  icon: ReactNode;
  title: ReactNode;
  onClick: () => void;
  hasBorder?: boolean;
}) => {
  return (
    <Box borderRadius="6px" width="100%" border={hasBorder ? `2px solid ${colors.orange600}` : ""}>
      <HStack
        borderRadius="6px"
        boxShadow="-2px -1px 4px 2px #00000022"
        onClick={onClick}
        alignItems="center"
        justifyContent="space-between"
        padding="6px 2px"
        gap="6px"
      >
        <Box textAlign="center" whiteSpace="pre" margin="auto" className="body_14_m gray700">
          {title}
        </Box>
      </HStack>
    </Box>
  );
};

const CopyAddressButton = ({ address }: { address: string }) => {
  const copyAddress = () => {
    customEvent({
      newGtm: {
        path: "parlor_detail",
        trigger_and_target: "copy-copy_address",
      },
      hackle: { key: HackleEventName["장례식장 상세 - 주소 복사"] },
    });
    navigator.clipboard.writeText(address).then(() => {
      alert("주소가 복사되었습니다.");
    });
  };
  return (
    <HStack
      as="button"
      onClick={copyAddress}
      style={{
        minWidth: "70px",
      }}
      border={`1px solid ${colors.gray100}`}
      borderBottom={`1px solid ${colors.gray100}`}
      padding="2px 4px"
      gap={1}
      borderRadius="4px"
    >
      <ColorIcon name="content-copy-outline" color={colors.gray300} width="16px" height="16px" />
      <div className="caption1 gray300">복사하기</div>
    </HStack>
  );
};

export default MainInfoSection;
